import type { ComponentType } from 'react'
import type { GraphicKind, StageGraphic } from '@/lib/watch/graphics'
import { AthleteLowerThird } from './AthleteLowerThird'
import type { BroadcastElementProps } from './context'
import { StandingsPanel } from './StandingsPanel'

/**
 * Each kind of broadcast element's component (docs/features/badger-cohost.md, Primitives). A new element is one
 * component, one entry here, its reader in `lib/watch/graphics.ts` (which says its slot) and a story; the type keeps
 * the two lists in step.
 */
export const BROADCAST_ELEMENTS: { [K in GraphicKind]: ComponentType<BroadcastElementProps<Extract<StageGraphic, { kind: K }>>> } = {
  athlete: AthleteLowerThird,
  standings: StandingsPanel,
}

/** The element a spec names, drawn by its kind's component. */
export function BroadcastElement({ spec, ...props }: BroadcastElementProps) {
  const Element = BROADCAST_ELEMENTS[spec.kind] as ComponentType<BroadcastElementProps>
  return <Element spec={spec} {...props} />
}
